import { ColumnViewModel } from '../../shared/column-types';

export const numVariantsAssociatedToDisease_SUMMARY: ColumnViewModel = {
  columns: [
    'diseaseName',
    'diseaseUMLSCUI',
    'variantStrID',
    'geneSymbol',
    'geneNcbiIDs',
    'numDiseasesAssociatedToVariant',
    'score',
    'sourceScore',
    'mostSevereConsequences',
    'numPMIDsupportingAssociation',
    'numberChemsIncludedInEvidence',
    'numberPmidsWithChemsIncludedInEvidence',
    'yearInitial',
    'yearFinal',
    'EI',
    'variantDSI',
    'variantDPI',
    'chromosome',
    'hgvsc',
    'hgvsp',
    'coord',
    'alleles',
    'alleleFreqExome',
    'alleleFreqGenome',
    'DBSNPclass',
    'polyphen_score',
    'sift_score',
    'diseaseType',
    'diseaseClassName_MSH',
    'diseaseClassName_UMLS',
    'diseaseClassName_DO',
    'diseaseClassName_HPO',
  ],
  defaultVisible: [
    'variantStrID',
    'geneSymbol',
    'numDiseasesAssociatedToVariant',
    'score',
    'sourceScore',
    'mostSevereConsequences',
    'numPMIDsupportingAssociation',
    'yearInitial',
    'yearFinal',
    'EI',
    'variantDSI',
    'variantDPI',
    'chromosome',
    'coord',
  ],
};
